export default __webpack_public_path__ + "static/media/azure.6e06c048.png";